import { useState, useEffect } from 'react'

// A simple mapping of some common locales to their currencies
// In a real Shopify environment, this is handled by the backend/Shopify Markets
const getCurrencyForLocale = (locale: string) => {
  const countryCode = locale.split('-')[1]?.toUpperCase()
  const currencyMap: Record<string, string> = {
    US: 'USD',
    GB: 'GBP',
    EU: 'EUR',
    AR: 'ARS',
    MX: 'MXN',
    CO: 'COP',
    CL: 'CLP',
    PE: 'PEN',
    ES: 'EUR',
    CA: 'CAD',
    AU: 'AUD',
  }
  return currencyMap[countryCode] || 'USD'
}

export function usePriceDisplay(amount: number) {
  const [formattedPrice, setFormattedPrice] = useState(`$${amount.toFixed(2)}`)

  useEffect(() => {
    try {
      const userLocale = navigator.language || 'es-AR'
      const currency = getCurrencyForLocale(userLocale)

      const formatter = new Intl.NumberFormat(userLocale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

      // If the currency is not USD, we might want to apply a conversion rate in a real app.
      // For this static demo, we'll just format the base amount with the local currency symbol,
      // or fallback to USD if we want to keep the exact 16.99 value but localized format.
      setFormattedPrice(formatter.format(amount))
    } catch (error) {
      // Fallback if Intl fails
      setFormattedPrice(`$${amount.toFixed(2)}`)
    }
  }, [amount])

  return formattedPrice
}
